import { S3 } from "@aws-sdk/client-s3";
import { DeleteRequestAws, S3Object } from "js/models";
import moment from "moment";
import { Upload } from "@aws-sdk/lib-storage";
import urljoin from "url-join";

import { Credentials, Provider } from "@aws-sdk/types";
export class S3Helper {
    bucketName: string;
    region: string;
    s3: S3;

    constructor(
        bucketName: string,
        region: string,
        credentials: Credentials | Provider<Credentials>
    ) {
        this.bucketName = bucketName;
        this.region = region;

        this.s3 = new S3({
            region: region,
            credentials: credentials
        });
    }

    async createAWSBucket() {
        const response = await this.s3.createBucket({
            Bucket: this.bucketName
        });
        //   getLogger().info(`Bucket ${response.Location} created successfully`);
        return response.Location;
    }

    async deleteAWSBucket() {
        const params = {
            Bucket: this.bucketName
        };
        await this.s3.deleteBucket(params);
        //   getLogger().info(`Bucket ${this.bucketName} deleted successfully`);
    }

    async deleteMultipleObjectsFromS3(Objects: DeleteRequestAws[]) {
        const params = {
            Bucket: this.bucketName,
            Delete: {
                Objects: Objects,
                Quiet: false
            }
        };

        const response = await this.s3.deleteObjects(params);
        return response.Deleted;
    }

    async createFolderInBucket(objectKey: string) {
        const params = {
            Body: "", //anything
            Bucket: this.bucketName,
            Key: urljoin(objectKey, "/")
        };
        const response = await this.s3.putObject(params);
        return response;
    }

    async getBucketListing(prefix: string, continuationToken?: string) {
        const params = {
            Bucket: this.bucketName,
            MaxKeys: 1000,
            ContinuationToken: continuationToken,
            Prefix: prefix
        };
        if (!continuationToken) {
            delete params.ContinuationToken;
        }
        if (!prefix) {
            delete params.Prefix;
        }

        const response = await this.s3.listObjectsV2(params);
        return response;
    }

    async getDirectBucketListing(prefix: string, continuationToken?: string) {
        const params = {
            Bucket: this.bucketName,
            MaxKeys: 1000,
            ContinuationToken: continuationToken,
            Prefix: prefix,
            Delimiter: "/"
        };
        if (!continuationToken) {
            delete params.ContinuationToken;
        }
        if (!prefix) {
            delete params.Prefix;
        }

        const response = await this.s3.listObjectsV2(params);
        return response;
    }

    async UploadObject(
        obj: File,
        path: string,
        onProgress?: (progress: any) => void
    ) {
        const paralellUploads3 = new Upload({
            client: this.s3,
            queueSize: 4, // optional concurrency configuration
            partSize: 5 * 1024 * 1024, // optional size of each part
            leavePartsOnError: false, // optional manually handle dropped parts
            params: {
                Bucket: this.bucketName,
                Key: path,
                Body: obj,
                ACL: "public-read"
            }
        });

        paralellUploads3.on("httpUploadProgress", progress => {
            if (onProgress) {
                onProgress(Math.ceil((progress.loaded / progress.total) * 100));
            }
        });
        await paralellUploads3.done();
        return {
            Key: path,
            LastModified: moment().toDate(),
            Size: obj.size
        } as S3Object;
    }
    getPublicUrl(key: any) {
        const hostnamePrefix =
            this.region !== "us-east-1" ? "s3." + this.region : "s3";
        return `https://${this.bucketName}.${hostnamePrefix}.amazonaws.com/${key}`;
    }

    async listAllBuckets() {
        const response = await this.s3.listBuckets({});
        return response.Buckets;
    }
}
